import { render, staticRenderFns } from "./AnalyticsResultChartsDemographicsAge.vue?vue&type=template&id=1f2c2c0e&scoped=true"
import script from "./AnalyticsResultChartsDemographicsAge.vue?vue&type=script&lang=js"
export * from "./AnalyticsResultChartsDemographicsAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c2c0e",
  null
  
)

export default component.exports